<main class="container-fluid">
    <article class="row bg-white shadow my-3 mx-0">
        <section class="col-3 p-4 border-right">
            <header class="text-center mb-3">
                <label class="h5">{{!encuestaSatisfaccionIdSeleccionada ? 'Agregar' : 'Editar'}} encuesta de satisfacción</label>
            </header>

            <form [formGroup]="encuestaSatisfaccionForm" (ngSubmit)="guardarEncuestaSatisfaccion()">
                <div class="form-group">
                    <label class="text-secondary small" for="form_nombre">Nombre de encuesta</label>
                    <input type="text" id="form_nombre" formControlName="nombre" class="form-control form-control-sm" autocomplete="off">
                    <div class="form-text small text-danger" *ngIf="encuestaSatisfaccionForm.get('nombre').touched && encuestaSatisfaccionForm.get('nombre').hasError('required')">
                        Campo obligatorio.
                    </div>
                </div>
                <div class="form-group">
                    <label class="text-secondary small" for="form_fechaInicio">Fecha inicio</label>
                    <div class="input-group">
                        <input class="form-control form-control-sm" id="form_fechaInicio" formControlName="fechaInicio"
                            placeholder="yyyy/mm/dd" ngbDatepicker #fechaInicio="ngbDatepicker" (dateSelect)="onCheckDateForm($event)"
                            readonly="readonly">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="fechaInicio.toggle()" type="button"></button>
                        </div>
                    </div>
                    <div class="form-text small text-danger"
                        *ngIf="encuestaSatisfaccionForm.get('fechaInicio').touched && encuestaSatisfaccionForm.get('fechaInicio').hasError('required')">
                        Campo obligatorio.
                    </div>
                </div>
                <div class="form-group">
                    <label class="text-secondary small" for="form_fechaFinal">Fecha final</label>
                    <div class="input-group">
                        <input class="form-control form-control-sm" id="form_fechaFinal" formControlName="fechaFinal"
                            placeholder="yyyy/mm/dd" ngbDatepicker #fechaFinal="ngbDatepicker" [minDate]="fechaInicioMinima"
                            readonly="readonly">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="fechaFinal.toggle()" type="button"></button>
                        </div>
                    </div>
                    <div class="form-text small text-danger"
                        *ngIf="encuestaSatisfaccionForm.get('fechaFinal').touched && encuestaSatisfaccionForm.get('fechaFinal').hasError('required')">
                        Campo obligatorio.
                    </div>
                </div>
                <div class="form-group">
                    <label class="text-secondary small" for="form_interfaz">Identificador de interfaz</label>
                    <input type="text" id="form_interfaz" formControlName="identificadorInterfaz" class="form-control form-control-sm">
                    <div class="form-text small text-danger"
                        *ngIf="encuestaSatisfaccionForm.get('identificadorInterfaz').touched && encuestaSatisfaccionForm.get('identificadorInterfaz').hasError('required')">
                        Campo obligatorio.
                    </div>
                </div> 
                <button type="button" class="btn btn-primary btn-block"
                        (click)="abrirModalDePreguntas()">
                    Editar Encuesta
                </button>
                <ng-container *ngIf="!encuestaTienePreguntasConfiguradas">
                    <div class="text-muted small m-0">
                        No hay preguntas configuradas
                    </div>
                </ng-container>
                <ng-container *ngIf="encuestaTienePreguntasConfiguradas">
                <div class="text-success small m-0">
                    {{cantidadPreguntasConfiguradas}} pregunta(s) configurada(s)
                </div>
                </ng-container>
                
                <div class="form-group mt-3">
                    <label class="text-secondary small" for="form_activo">Estado</label>
                    <select id="form_activo" formControlName="activo" class="form-control form-control-sm">
                        <option [ngValue]="null"> Seleccione </option>
                        <option [ngValue]="true"> Activo </option>
                        <option [ngValue]="false"> Inactivo </option>
                    </select>
                    <div class="form-text small text-danger"
                        *ngIf="encuestaSatisfaccionForm.get('activo').touched && encuestaSatisfaccionForm.get('activo').hasError('required')">
                        Campo obligatorio.
                    </div>
                </div>
                
                <div class="form-row mt-4">
                    <button type="button" class="btn btn-outline-primary border-0 m-auto"
                            (click)="limpiarFormularioRegistroEncuestaSatisfaccion()">
                        Limpiar
                    </button>
                    <button type="submit" class="btn btn-primary m-auto" 
                            [disabled]="encuestaSatisfaccionForm.invalid">
                        {{!encuestaSatisfaccionIdSeleccionada ? "Guardar" : "Editar"}}
                    </button>
                </div>
            </form>
        </section>

        <section class="col-9 p-4">
            <div class="d-flex justify-content-between mb-3">
                <header class="row d-flex align-items-center">
                    <img src="assets/icons/solicitud.png" class="d-inline-block mr-2" height="40">
                    <label class="text-dark h5 mb-0 font-weight-bold">Encuesta de satisfacción</label>
                </header>
                <div class="filter-button-wrapper">
                    <button type="button" class="btn btn-outline-primary" (click)="showFilters = !showFilters"
                        [attr.aria-expanded]="showFilters" aria-controls="filtros">
                        Ver filtros
                    </button>
                </div>
            </div>

            <div id="collapsed-filters" [ngbCollapse]="!showFilters">
                <div class="card p-4 mb-3">
                    <form [formGroup]="filtrosForm" (submit)="buscarEncuestasConFiltro()">
                        <div class="row">
                            <div class="form-group col">
                                <label class="text-secondary small" for="filter_nombre">Nombre de encuesta</label>
                                <input type="text" id="filter_nombre" formControlName="nombre" 
                                    class="form-control form-control-sm">
                            </div>
                            <div class="form-group col">
                                <label class="text-secondary small" for="filter_fechaInicio">Fecha inicio</label>
                                <div class="input-group">
                                    <input class="form-control form-control-sm" id="filter_fechaInicio" formControlName="fechaInicio" placeholder="yyyy/mm/dd"
                                        ngbDatepicker #filterFechaInicio="ngbDatepicker" (dateSelect)="onCheckDateFilterForm($event)"
                                        readonly="readonly">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary calendar" (click)="filterFechaInicio.toggle()" type="button"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col">
                                <label class="text-secondary small" for="filter_fechaFinal">Fecha final</label>
                                <div class="input-group">
                                    <input class="form-control form-control-sm" id="filter_fechaFinal" formControlName="fechaFinal" placeholder="yyyy/mm/dd" ngbDatepicker
                                        #filterFechaFinal="ngbDatepicker" readonly="readonly" [minDate]="filtro_fechaInicioMinima">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary calendar" (click)="filterFechaFinal.toggle()" type="button"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col">
                                <label class="text-secondary small" for="filter_interfaz">Interfaz</label>
                                <input type="text" id="filter_interfaz" formControlName="identificadorInterfaz" 
                                    class="form-control form-control-sm">
                            </div>
                            <div class="form-group col">
                                <label class="text-secondary small" for="filter_activo">Estado</label>
                                <select id="filter_activo" formControlName="activo" class="form-control form-control-sm">
                                    <option [ngValue]="null"> Seleccione </option>
                                    <option [ngValue]="true"> Activo </option>
                                    <option [ngValue]="false"> Inactivo </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <button type="reset"  class="btn btn-outline-primary border-0 mr-2" (click)="limpiarFiltrosDeBusqueda()">Limpiar</button>
                            <button type="submit" class="btn btn-primary">Filtrar</button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="table-responsive">
                <app-tablas
                        [headers]="headerTable"
                        [page]="paginaActual" 
                        [sizeData]="dataTable.paging.totalItems" 
                        (paginado)="onPaginado($event)">
                    <tbody>
                        <tr class="small" *ngFor="let item of dataTable.items; let i=index">
                            <td>{{item.nombre}}</td>
                            <td>{{item.fechaInicio | date: 'dd-MM-yyyy'}}</td>
                            <td>{{item.fechaFinal | date: 'dd-MM-yyyy'}}</td>
                            <td>{{item.identificadorInterfaz}}</td>
                            <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
                            <td>
                                <img src="assets/icons/edit.png" class="pointer mr-2" height="25"
                                    (click)="seleccionarEncuestaSatisfaccion(item)" matTooltip="Editar" matTooltipPosition="left">
                                <img src="assets/icons/delete.png" class="pointer" height="25"
                                    (click)="eliminarEncuestaSatisfaccion(item)" matTooltip="Eliminar" matTooltipPosition="left">
                            </td>
                        </tr>
                    </tbody>
                </app-tablas>
            </div>
        </section>
    </article>
</main>